module.exports = __webpack_public_path__ + "img/hotdog-top-sra002.e82e297f.jpg";